export type ListQueryParams = {
    top?: number;
    skip?: number;
    orderBy?: string;
};

export const toQueryString = (params: ListQueryParams): string => {
    const queryString = new URLSearchParams();
    if (params.top !== undefined) queryString.set('$top', String(params.top));
    if (params.skip !== undefined) queryString.set('$skip', String(params.skip));
    if (params.orderBy) queryString.set('$orderby', params.orderBy);
    return queryString.toString();
};
